
import { Drawer, Button } from 'element-ui';

export default {
  data() {
    return {
      drawer: true,
      direction: 'rtl',
      active: 1,
      toggleMenu: false,
    };
  },
  computed: {
    cartItem() {
      return this.$store.state.shop.cart.listItemLocal;
    },
    title() {
      return 'Mon compte';
    },

    currencySign() {
      return this.$localisation.currencySign;
    },
  },

  methods: {},
  components: {
    Drawer,
    Button,
  },
};
